import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { formatDate1122 } from "../../../../CloudStorage/CommonFunction";
import { getDateFormate } from "../../../Common/AllDateTimeReleventFormate";

const Months = ({ setFirstdate, setLastdate, start_date, end_date }) => {
    const [startDate, setStartDate] = useState(start_date ? new Date(start_date) : null);
    const [endDate, setEndDate] = useState(end_date ? new Date(end_date) : null);

    const handleDatesSet = (arg) => {
        // always force first date = first day of month
        const baseDate = new Date(arg.start);
        const firstDate = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);

        // calculate last date = last day of month after +6 months (7 months total)
        const lastDate = new Date(firstDate);
        lastDate.setMonth(firstDate.getMonth() + 6);
        lastDate.setMonth(lastDate.getMonth() + 1);
        lastDate.setDate(0); // sets to the last day of previous month

        if (setFirstdate) setFirstdate(formatDate1122(firstDate));
        if (setLastdate) setLastdate(formatDate1122(lastDate));

        setStartDate(firstDate);
        setEndDate(lastDate);
    };

    // ✅ Display as "Aug 2025 - Feb 2026"
    const getFormattedTitle = () => {
        if (!startDate || !endDate) return "";
        const startLabel = startDate.toLocaleString("default", {
            month: "short",
            year: "numeric",
        });
        const endLabel = endDate.toLocaleString("default", {
            month: "short",
            year: "numeric",
        });
        return `${startLabel} - ${endLabel}`;
    };

    return (
        <div style={{ position: "relative" }}>
            <FullCalendar
                plugins={[dayGridPlugin]}
                initialView="dayGridMonth"
                headerToolbar={{
                    left: "prev",
                    center: "customTitle",
                    right: "next",
                }}
                events={[]}
                datesSet={handleDatesSet}
                customButtons={{
                    customTitle: {
                        text: getFormattedTitle(),
                    },
                }}
                headerContent={() => (
                    <h2 style={{ margin: 0 }}>{getFormattedTitle()}</h2>
                )}
                dayRender={(info) => {
                    info.el.style.display = "none";
                }}
                eventDidMount={(info) => {
                    info.el.style.display = "none";
                }}
            />
            <style>
                {`
                    .fc-view {
                        display: none; 
                    }
                `}
            </style>
        </div>
    );
};

export default Months;
